import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dec5bae6")

_pushScopeId("data-v-dec5bae6")
const _hoisted_1 = { class: "guide" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("您的位置:")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("帮助")
const _hoisted_6 = { class: "main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_guide_nav = _resolveComponent("guide-nav")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_breadcrumb, { separator: "/" }, {
        default: _withId(() => [
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, {
            to: { path: '/main' },
            onClick: _ctx.toHome
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_container, null, {
      default: _withId(() => [
        _createVNode(_component_el_aside, { width: "200px" }, {
          default: _withId(() => [
            _createVNode(_component_guide_nav)
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_router_view)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})